// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage"
import { getFirestore } from "firebase/firestore"

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCHtty9-ZVuLJgIr_ueffxXHpZEzqDb17E",
  authDomain: "mam-app-au.firebaseapp.com",
  projectId: "mam-app-au",
  storageBucket: "mam-app-au.appspot.com",
  messagingSenderId: "68505931526",
  appId: "1:68505931526:web:394ab1a2885287806e5887",
  measurementId: "G-7BXXPK6B2F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getFirestore(app)
export const storage = getStorage(app)
